<template>
  <div id="app">
    <MobileNav
      :showNav="showMobileNav"
      @hideNav="hideMobileNav"
    />
    <Header @showMobileNav="displayMobileNav" />
    <main class="page-container">
      <router-view/>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import MobileNav from '@/components/MobileNav.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    MobileNav
  },
  data() {
    return {
      showMobileNav: false
    }
  },
  methods: {
    displayMobileNav() {
      this.showMobileNav = true
    },
    hideMobileNav() {
      this.showMobileNav = false
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.page-container {
  max-width: 1024px;
  margin: 16px 8px;

  @media (min-width: 400px) {
    margin: 24px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue